export const enum CancelReasons_enum {
  GUEST_DELAY = "guest_delay",
  NOT_READY = "not_ready",
  ALREADY_RESERVED = "already_reserved",
  OTHER = "other",
}
